<template>
  <div>
    <!-- Mobile Skeleton View -->
    <div class="flex flex-col w-full lg:hidden">
      <div v-for="n in count" :key="n" class="border-t border-gray-800 py-4">
        <div class="w-full">
          <!-- Row 1: Event Logo, Teams, and Scores Skeleton -->
          <div class="flex items-stretch gap-1 mb-3">
            <!-- Event Logo Box Skeleton -->
            <div class="w-[52px] h-[52px] bg-gray-800 rounded flex items-center justify-center flex-shrink-0 animate-pulse">
              <div class="w-6 h-6 bg-gray-700 rounded" />
            </div>

            <!-- Scores and Teams Skeleton -->
            <div class="flex flex-col gap-1 flex-1">
              <!-- Team 1 Row Skeleton -->
              <div class="flex items-center gap-2">
                <div class="w-6 h-5 bg-gray-800 rounded animate-pulse" />
                <div class="w-4 h-4 bg-gray-800 rounded animate-pulse" />
                <div class="h-3 bg-gray-800 rounded animate-pulse w-20" />
              </div>

              <!-- Team 2 Row Skeleton -->
              <div class="flex items-center gap-2">
                <div class="w-6 h-5 bg-gray-800 rounded animate-pulse" />
                <div class="w-4 h-4 bg-gray-800 rounded animate-pulse" />
                <div class="h-3 bg-gray-800 rounded animate-pulse w-20" />
              </div>
            </div>
          </div>

          <!-- Row 2: Event, Date, Format, and Action Skeleton -->
          <div class="grid grid-cols-2 gap-4">
            <!-- Left Column Skeleton -->
            <div class="flex flex-col gap-1">
              <div class="h-3 bg-gray-800 rounded animate-pulse w-12" />
              <div class="h-4 bg-gray-800 rounded animate-pulse w-24" />
              <div class="h-3 bg-gray-800 rounded animate-pulse w-20" />
            </div>

            <!-- Right Column Skeleton -->
            <div class="flex flex-col gap-1 items-end">
              <div class="h-3 bg-gray-800 rounded animate-pulse w-12" />
              <div class="h-4 bg-gray-800 rounded animate-pulse w-16" />
              <div class="h-8 bg-gray-800 rounded animate-pulse w-24" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Desktop Skeleton View -->
    <div class="bg-gray-900 px-5 rounded-lg sm:px-6 hidden lg:block">
      <div class="sm:-mx-6">
        <div class="align-middle inline-block min-w-full">
          <table class="min-w-full divide-y divide-gray-950 table-auto">
            <tbody class="divide-y divide-gray-950">
              <tr v-for="n in count" :key="n" class="animate-pulse">
                <!-- Scores and Teams Column Skeleton -->
                <td class="px-3 py-3 whitespace-nowrap">
                  <div class="flex items-stretch gap-1">
                    <!-- Event Logo Box Skeleton -->
                    <div class="w-[52px] h-[52px] bg-gray-800 rounded flex items-center justify-center flex-shrink-0">
                      <div class="w-6 h-6 bg-gray-700 rounded" />
                    </div>

                    <!-- Scores and Teams Skeleton -->
                    <div class="flex flex-col gap-1">
                      <!-- Team 1 Row Skeleton -->
                      <div class="flex items-center gap-2">
                        <div class="w-6 h-5 bg-gray-800 rounded" />
                        <div class="w-4 h-4 bg-gray-800 rounded" />
                        <div class="h-3 bg-gray-800 rounded w-20" />
                      </div>

                      <!-- Team 2 Row Skeleton -->
                      <div class="flex items-center gap-2">
                        <div class="w-6 h-5 bg-gray-800 rounded" />
                        <div class="w-4 h-4 bg-gray-800 rounded" />
                        <div class="h-3 bg-gray-800 rounded w-20" />
                      </div>
                    </div>
                  </div>
                </td>

                <!-- Event Column Skeleton -->
                <td class="px-3 py-3 whitespace-nowrap">
                  <div class="h-4 bg-gray-800 rounded w-32" />
                </td>

                <!-- Date Column Skeleton -->
                <td class="px-3 py-3 whitespace-nowrap">
                  <div class="h-3 bg-gray-800 rounded w-24" />
                </td>

                <!-- Format Column Skeleton -->
                <td class="px-3 py-3 whitespace-nowrap">
                  <div class="h-3 bg-gray-800 rounded w-16" />
                </td>

                <!-- Action Column Skeleton -->
                <td class="px-4 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <div class="w-8 h-8 bg-gray-800 rounded-md" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  count: {
    type: Number,
    default: 6,
  },
});
</script>
